<template>
    <section>
        <b-overlay :show="loading" rounded="sm">
            <b-tabs no-fade pills card  nav-class="nav-style">
                <b-tab title="Grafica" active>
                    <chart :options="chartOptions"  ref="chart"></chart>
                </b-tab>
                <b-tab title="Detalle" v-if="true">
                    <div class="text-right mb-2">
                        <b-button @click="excel" variant="success">
                        Descargar
                        </b-button>
                    </div>

                    <b-tabs no-fade pills card small vertical nav-class="nav-style">
                        <b-tab v-for="(item, i) in table" :key="`tab-${i}`"  :title="i" lazy >
                            <PaginatedTable :items="item" />
                        </b-tab>
                    </b-tabs>
                </b-tab>
            </b-tabs>
          
            <span>Total:${{totalRides}}</span>
        </b-overlay>
    </section>
</template>
<script>
    import {Chart} from 'highcharts-vue'
    import api from '../../../../../api.js'
    import Highcharts from 'highcharts'
    import exportingInit from 'highcharts/modules/exporting'
    exportingInit(Highcharts)
    import PaginatedTable from './TableIncomeMoneyProjection.vue';
    export default {
        name: "IncomeMoneyProjection",
        components:{Chart,PaginatedTable},
        props: {
            filters: {
                type : Object,
                required: true
            },
            triggerSearch:{
                type : Number,
                required: true
            }
        },
        data(){
            let seriesExample = [{
                name:"",
                data:[]
            }];


            return {
                originalSeries:[],
                totalRides:0,
                loading:false,
                exporting: {
                    enabled: true
                },
                codeReport : "income-money-projection",
                chartOptions:{
                    title: {
                        text: 'Proyeccion de ingreso'
                    },
                    tooltip: {
                        formatter: function(tooltip) {
                            let original = tooltip.defaultFormatter.call(this, tooltip);
                            let detalle   = this.point.details??{};
                            for (let status in detalle ){
                                original.push(status+"= <b>"+detalle[status]+"</b><br/>");
                            }
                            return original;
                        }
                    },
                    yAxis: {
                        title: {
                            text: ''
                        }
                    },
                    exporting:{
                        buttons:{
                            menuItems:["viewFullscreen"]
                        }
                    },
                    chart:{
                        type:'pie'
                    },
                    series: seriesExample,
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: true,
                                format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                            }
                        }
                    }


                },
                table:[]
            }
        },
        methods:{
            fetchDataChart(){
                this.loading=true;
                this.filters.xls = false;
                api(this).get(`/dashboard/admin/charts/${this.codeReport}`,{params: {filters:this.filters}}).then((res) => {
                    this.totalRides                        = res.data.totalRides;
                    this.originalSeries                    = res.data.series;
                    this.chartOptions.series               = res.data.series;
                    //this.table   = res.data.table;
                    this.table = JSON.parse(JSON.stringify(res.data.table));

                }).catch(this.$root.handleRequestError).finally(()=>this.loading=false)
            },
            excel(){
				this.loading = true
                this.filters.xls = true;
                api(this).get(`/dashboard/admin/charts/${this.codeReport}`,{
                    params: {filters:this.filters},
                    responseType:"blob"
                })
				.then((res) => {
					this.$root.downloadExcel(res, "Proyeccion de ingresos");
				}).catch(error => {
					console.log("--->",error);
					let errorNew = new Error(["Verifique la información"]);
					this.$root.handleRequestError(errorNew)
				}).finally(()=>{
                    this.loading = false;
                    this.filters.xls = false;
                });

			},
        },
        watch:{
            triggerSearch(){//este valor es reactivo, el padre decide en que momento se dispara la busqueda
                this.fetchDataChart();
            }
        },
        mounted() {
            if(this.triggerSearch>0){
                this.fetchDataChart();
            }
        }
    }
</script>

<style scoped>

</style>